import { RoleGuard } from '@agyletime/vue-3-common/src/routes/guard';

export const OperationsAdminRequiredRole = 'edit_operations_configurations';

export const AdminNavigationGuard = [RoleGuard([OperationsAdminRequiredRole], true)];